import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import * as moment from 'moment';
import { environment } from 'environments/environment';


@Component({
  selector: 'app-group-ui',
  templateUrl: './group-ui.component.html',
  styleUrls: ['./group-ui.component.css']
})
export class GroupUiComponent implements OnInit {
  @Input() groups: any;
  @Input() reservations: any[];
  @Input() pageName: string;
  @Input() leaderUid: string;
  @Output() saveData: EventEmitter<any> = new EventEmitter();
  @Output() seeReservation: EventEmitter<any> = new EventEmitter();
  imageURL = environment.URL_TEAM_IMAGES;

  constructor() { }

  ngOnInit() {
  }

  seeTickets(group) {
    this.saveData.emit(group);
  }

  selectReservation(reservation) {
    this.seeReservation.emit(reservation);
  }

  /*   getGroupImage(imageUrl) {
      return this.imgHandle + imageUrl;
    } */

  getGroupCreatedTimeStamp(tstamp) {
    const momNow = moment();
    const now = (Date.now() / 1000);
    const diff = now - tstamp;
    const date = moment.unix(Number(tstamp));
    const diffDays = momNow.diff(date, 'days');
    const diffMin = momNow.diff(date, 'minutes');
    const diffHours = momNow.diff(date, 'hours');

    // show 1 minute default
    if (diff < 120) {
      return String('1 minute ago');
    } else if (diffMin < 60) {
      return diffMin + ' minutes ago';
    } else if (diffHours < 24) {
      return diffHours + ' hours ago';
    } else {
      return (diffDays + 1) + ' days ago';
    }
  }

  getGroupStatusText(group) {
    switch (group.group_status) {
      case ('SEAT_RESERVED'):
        return 'Waiting for group leader to finalize members';
      case ('SEAT_PENDING'):
        return 'Waiting for team to release season schedule. Tap to view details.';
      case ('PENDING_SCHEDULE'):
        return 'Waiting for group leader to schedule draft';
      case ('LOCKED'):
        return 'Group leader will set ticket draft time upon team schedule release';
      case ('SCHEDULED'):
        return 'Draft scheduled. Click to see date.';
      case ('EXPIRED'):
        return 'Draft window closed. Please reschedule ticket draft.';
      case ('PAYMENT_FAILED'):
        return 'Group payment failed. Please contact support.';
      case ('DRAFT'):
        return 'Draft in progress. Click to join.';
      case ('SPLIT_PENDING'):
        return 'Your tickets will be available shortly ';
      case ('OPEN'):
        return 'Waiting for group leader to start draft.';
      case ('PENDING_CONFIRM'):
        if(group.type == "PUBLIC" && group.leader_uid==this.leaderUid){
          return 'Your Tickets Sold! You will be notified when funds are processed.';
        } else {
          return 'Your tickets will be available shortly. ';
        }
      case ('COMPLETE'):
      if(group.type == "PUBLIC" && group.leader_uid==this.leaderUid){
        return 'Your Tickets Sold! Funds were transferred to your payment method on file.';
      } else {
        return 'Tickets are available to access in your Team Account.';
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/reusable/group-ui/group-ui.component.ts